import validators from '../../utils/validators';

class DrugMethod {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      name: (v) => validators.isNotEmptyString(v),
      sort: (v) => validators.isNumber(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid DrugMethod property '${property}' in ${data.id}`);
      }

      this[property] = data[property];
    }
  }
}

export default DrugMethod;
